import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { IntlService } from 'ember-intl';
import type { AppServicesWaldenConnectClientModel } from 'walden-fast/routes/app/services/walden-connect/client';
import type ModalService from 'walden-fast/services/modal';
import type { ConnectInterface } from 'walden-fast/types/connect-interface';

export default class AppServicesWaldenConnectClientController extends Controller {
  declare model: AppServicesWaldenConnectClientModel;

  @service('intl') declare intlService: IntlService;
  @service('modal') declare modalService: ModalService;

  activateInterfaceModal = 'activate-interface';

  @tracked
  selectedInterface: ConnectInterface | null = null;

  @action
  activateInterface(data: ConnectInterface) {
    this.selectedInterface = data;
    this.modalService.open(this.activateInterfaceModal);
  }
}
